import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid/main';

@Component({
  selector: 'lfwms-pinned-cell-renderer',
  templateUrl: './pinned-cell-renderer.component.html',
  styleUrls: ['./pinned-cell-renderer.component.css']
})
export class PinnedCellRendererComponent implements ICellRendererAngularComp {

  public isLoading: boolean = true;
  public templateId: number = 0;
  public params: any;
  public cellValue: any = '';

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    //[LFWMS-3524] - Added template2 switch case for dock door details shipment table.
    if (this.params.value && this.params.value.templateId) {
      this.templateId = this.params.value.templateId;
      this.cellValue = this.params.value.cVal;
    } else if (this.params.column.colDef.colId === 'isSelected') {
      this.templateId = 1;
    } else {
      this.cellValue = this.params.value.cVal;
    }
    this.isLoading = false;
  }

  public refresh(): boolean {
    return true;
  }

}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/search/results/result-data-table/renderers/pinned-cell-renderer/pinned-cell-renderer.component.ts